import React, { useEffect, useState } from "react";
import CommonModal from "../../Components/CommonModal";
import SceenLoader from "../../Components/ScreenLoader";
import CommonTable from "../../Components/CommonTable";
import { show_vendors_details_data } from "../../services";

function ShowVendorsDetailsData({ id, show, name, ...props }) {
    const [showVendorsDetailData, setShowVendorsDetailData] = useState([]);
    const [loading, setIsLoading] = useState(false);
    const [sortBy, setSortBy] = useState("");

    const fetchVendorsDetailsData = async () => {
        try {
            setIsLoading(true);
            const params = {
                target_organization_id: id,
                sort_by: sortBy,
            };

            const response = await show_vendors_details_data(params);
            console.log("response!!!!!!!!!", response);

            const detailsData =
                response?.statusCode?.response_data?.data || [];
            setShowVendorsDetailData(detailsData);
        } catch (error) {
            console.error("Error fetching vendor details:", error);
            setShowVendorsDetailData([]);
        } finally {
            setIsLoading(false);
        }
    };

    const headers = [
        "Category",
        "Finding",
        <span key="issue_count" onClick={() => setSortBy("issue_count")} className="cursor_pointer">
            Issue Count <img src="https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/arrow-down-up.svg" alt="sort" height={16} weight={16} />
        </span>,
        <span key="severity" onClick={() => setSortBy("severity")} className="cursor_pointer">
            Severity <img src="https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/arrow-down-up.svg" alt="sort" height={16} weight={16} />
        </span>,
        "MITRE | ATT&CK",
    ];

    const getSeverityImage = (severity) => {
        switch (severity?.toLowerCase()) {
            case "low":
                return "https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/low-icon.svg";
            case "medium":
                return "https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/medium-icon.svg";
            case "high":
                return "https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/high-icon.svg";
            case "critical":
                return "https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/critical-icon.svg";
            default:
                return "https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/default-icon.png";
        }
    };

    const rows = showVendorsDetailData?.map((item, index) => ({
        key: index,
        data: [
            <div className="dark_blue_text" key={`cat-${index}`}>
                {item?.category || "-"}
            </div>,
            item?.finding || "-",
            <div className="dark_blue_text" key={`issue-${index}`}>
                {item?.issue_count || "-"}
            </div>,
            <span
                className="d-flex align-items-center gap-2"
                key={`sev-${item?.id || index}`}
            >
                <img src={getSeverityImage(item?.severity)} alt={item?.severity} height={12} width={12} />
                {item?.severity || "-"}
            </span>,
            item?.mitre_tag || "-",
        ],
    }));

    useEffect(() => {
        if (id) {
            fetchVendorsDetailsData();
        }
    }, [id, sortBy]);

    useEffect(() => {
        if (show) {
            document.body.classList.add("modal-blur-background");
        } else {
            document.body.classList.remove("modal-blur-background");
        }
        return () => {
            document.body.classList.remove("modal-blur-background");
        };
    }, [show]);

    return (
        <CommonModal show={show} onHide={props.onHide} size="xl" title={name}>
            {loading ? (
                <div className="mb-5">
                    <SceenLoader />
                </div>
            ) : rows && rows.length > 0 ? (
                <CommonTable headers={headers} rows={rows} noPadding noScroll />
            ) : (
                <div className="text-center my-5">No Details found</div>
            )}
        </CommonModal>
    );
}

export default ShowVendorsDetailsData;
